var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BasketItem } from "./schema";
import { SERVICE_TYPE_DEVICE_INSURANCE, } from "../../schema";
import { Storage } from "../../core/storage";
import { TrackingAddToCart } from "../tracking";
import { TrackingCartRemoveUpdate, TrackingCartAddUpdate } from "../tracking";
import { ProductsService } from "../products";
import { findOneById } from "../tariff";
var BasketAssistant = /*@__PURE__*/ (function () {
    function BasketAssistant() {
    }
    Object.defineProperty(BasketAssistant, "storage", {
        get: function () {
            return Storage.getHelper();
        },
        enumerable: true,
        configurable: true
    });
    BasketAssistant.updateItems = function (items) {
        return __awaiter(this, void 0, void 0, function () {
            var basketItems, _a, _b, _i, offerId, _c, _d, _e, offerId;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, BasketAssistant.getItems()];
                    case 1:
                        basketItems = _f.sent();
                        _a = [];
                        for (_b in basketItems)
                            _a.push(_b);
                        _i = 0;
                        _f.label = 2;
                    case 2:
                        if (!(_i < _a.length))
                            return [3 /*break*/, 5];
                        offerId = _a[_i];
                        return [4 /*yield*/, BasketAssistant.removeItem(basketItems[offerId], false)];
                    case 3:
                        _f.sent();
                        _f.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5:
                        _c = [];
                        for (_d in items)
                            _c.push(_d);
                        _e = 0;
                        _f.label = 6;
                    case 6:
                        if (!(_e < _c.length))
                            return [3 /*break*/, 9];
                        offerId = _c[_e];
                        return [4 /*yield*/, BasketAssistant.addOffer(items[offerId].offer, items[offerId].amount, false)];
                    case 7:
                        _f.sent();
                        _f.label = 8;
                    case 8:
                        _e++;
                        return [3 /*break*/, 6];
                    case 9:
                        BasketAssistant.setThunderBasket();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketAssistant.removeAllItems = function (force) {
        return __awaiter(this, void 0, void 0, function () {
            var basketItems, cartRemoveTracking, _a, _b, _i, itemKey, item, tariff, product, offer, kiasCode, amount, _c, _d, component, e_1, storage, result, callbacks, _e, callbacks_1, callback;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (!!force)
                            return [3 /*break*/, 12];
                        return [4 /*yield*/, BasketAssistant.getItems()];
                    case 1:
                        basketItems = _f.sent();
                        cartRemoveTracking = new TrackingCartRemoveUpdate();
                        _a = [];
                        for (_b in basketItems)
                            _a.push(_b);
                        _i = 0;
                        _f.label = 2;
                    case 2:
                        if (!(_i < _a.length))
                            return [3 /*break*/, 12];
                        itemKey = _a[_i];
                        _f.label = 3;
                    case 3:
                        _f.trys.push([3, 10, , 11]);
                        item = basketItems[itemKey];
                        tariff = void 0;
                        product = void 0;
                        offer = void 0;
                        kiasCode = void 0;
                        amount = void 0;
                        _c = 0, _d = item.offer.components;
                        _f.label = 4;
                    case 4:
                        if (!(_c < _d.length))
                            return [3 /*break*/, 9];
                        component = _d[_c];
                        if (!(component.type === "hardwareMobile"))
                            return [3 /*break*/, 6];
                        return [4 /*yield*/, ProductsService.findOneById(component.refId)];
                    case 5:
                        product = _f.sent();
                        _f.label = 6;
                    case 6:
                        if (!(component.type === "tariffMobile"))
                            return [3 /*break*/, 8];
                        return [4 /*yield*/, findOneById(component.refId)];
                    case 7:
                        tariff = _f.sent();
                        _f.label = 8;
                    case 8:
                        _c++;
                        return [3 /*break*/, 4];
                    case 9:
                        offer = item.offer;
                        kiasCode = tariff.getKIASCode();
                        amount = item.amount;
                        cartRemoveTracking.addOOrder(tariff, product, offer, kiasCode, amount);
                        cartRemoveTracking.track();
                        return [3 /*break*/, 11];
                    case 10:
                        e_1 = _f.sent();
                        console.log("Error removing Items from basket");
                        return [3 /*break*/, 11];
                    case 11:
                        _i++;
                        return [3 /*break*/, 2];
                    case 12:
                        storage = BasketAssistant.storage;
                        BasketAssistant.updateLastModifiedDate();
                        return [4 /*yield*/, storage.setItem("basket", "{}")];
                    case 13:
                        result = _f.sent();
                        callbacks = BasketAssistant.eventListeners.itemsDeleted;
                        for (_e = 0, callbacks_1 = callbacks; _e < callbacks_1.length; _e++) {
                            callback = callbacks_1[_e];
                            callback([]);
                        }
                        this.setThunderBasket();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketAssistant.updateItem = function (item, newOffer) {
        return __awaiter(this, void 0, void 0, function () {
            var storage, itemsDecoded, optionsStr, callbacks, _i, callbacks_2, callback;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storage = BasketAssistant.storage;
                        return [4 /*yield*/, BasketAssistant.getItems()];
                    case 1:
                        itemsDecoded = _a.sent();
                        optionsStr = item.offer.usedOptions.reduce(function (acc, curr) { return acc + "+" + curr.id; }, "");
                        if (!itemsDecoded[item.offer.id + optionsStr])
                            return [3 /*break*/, 4];
                        return [4 /*yield*/, BasketAssistant.removeItem(item, false)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, BasketAssistant.addOffer(newOffer, item.amount, false)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        BasketAssistant.updateLastModifiedDate();
                        callbacks = BasketAssistant.eventListeners.itemsRefreshed;
                        for (_i = 0, callbacks_2 = callbacks; _i < callbacks_2.length; _i++) {
                            callback = callbacks_2[_i];
                            callback(itemsDecoded);
                        }
                        BasketAssistant.setThunderBasket();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketAssistant.removeItem = function (item, track) {
        if (track === void 0) {
            track = true;
        }
        return __awaiter(this, void 0, void 0, function () {
            var storage, itemsDecoded, equalOfferId, result, callbacks, _i, callbacks_3, callback, cartRemoveTracking, tariff, product, offer, kiasCode, amount, _a, _b, component, e_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        storage = BasketAssistant.storage;
                        return [4 /*yield*/, BasketAssistant.getItems()];
                    case 1:
                        itemsDecoded = _c.sent();
                        return [4 /*yield*/, BasketAssistant.getEqualBasketItem(item.offer, itemsDecoded)];
                    case 2:
                        equalOfferId = _c.sent();
                        if (itemsDecoded[equalOfferId]) {
                            delete itemsDecoded[equalOfferId];
                        }
                        BasketAssistant.updateLastModifiedDate();
                        return [4 /*yield*/, storage.setItem("basket", JSON.stringify(itemsDecoded))];
                    case 3:
                        result = _c.sent();
                        callbacks = BasketAssistant.eventListeners.itemsDeleted;
                        for (_i = 0, callbacks_3 = callbacks; _i < callbacks_3.length; _i++) {
                            callback = callbacks_3[_i];
                            callback(itemsDecoded);
                        }
                        return [4 /*yield*/, BasketAssistant.setThunderBasket()];
                    case 4:
                        _c.sent();
                        if (!track)
                            return [3 /*break*/, 13];
                        _c.label = 5;
                    case 5:
                        _c.trys.push([5, 12, , 13]);
                        cartRemoveTracking = new TrackingCartRemoveUpdate();
                        tariff = void 0;
                        product = void 0;
                        offer = void 0;
                        kiasCode = void 0;
                        amount = void 0;
                        _a = 0, _b = item.offer.components;
                        _c.label = 6;
                    case 6:
                        if (!(_a < _b.length))
                            return [3 /*break*/, 11];
                        component = _b[_a];
                        if (!(component.type === "hardwareMobile"))
                            return [3 /*break*/, 8];
                        return [4 /*yield*/, ProductsService.findOneById(component.refId)];
                    case 7:
                        product = _c.sent();
                        _c.label = 8;
                    case 8:
                        if (!(component.type === "tariffMobile"))
                            return [3 /*break*/, 10];
                        return [4 /*yield*/, findOneById(component.refId)];
                    case 9:
                        tariff = _c.sent();
                        _c.label = 10;
                    case 10:
                        _a++;
                        return [3 /*break*/, 6];
                    case 11:
                        offer = item.offer;
                        kiasCode = tariff.getKIASCode();
                        amount = item.amount;
                        cartRemoveTracking.addOOrder(tariff, product, offer, kiasCode, amount);
                        cartRemoveTracking.track();
                        return [3 /*break*/, 13];
                    case 12:
                        e_2 = _c.sent();
                        return [3 /*break*/, 13];
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    BasketAssistant.addOptionToAllItems = function (optionId) {
        return __awaiter(this, void 0, void 0, function () {
            var itemsDecoded, update, offerId, offer, voucherOptionalService;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BasketAssistant.getItems()];
                    case 1:
                        itemsDecoded = _a.sent();
                        update = false;
                        for (offerId in itemsDecoded) {
                            offer = itemsDecoded[offerId].offer;
                            voucherOptionalService = offer.getOptionalServiceByID(optionId);
                            if (voucherOptionalService &&
                                offer.useOption(voucherOptionalService)) {
                                itemsDecoded[offerId].offer = offer;
                                update = true;
                            }
                        }
                        if (!update)
                            return [3 /*break*/, 3];
                        return [4 /*yield*/, BasketAssistant.updateItems(itemsDecoded)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    BasketAssistant.removeOptionFromAllItems = function (optionId) {
        return __awaiter(this, void 0, void 0, function () {
            var itemsDecoded, update, offerId, offer, voucherOptionalService;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BasketAssistant.getItems()];
                    case 1:
                        itemsDecoded = _a.sent();
                        update = false;
                        for (offerId in itemsDecoded) {
                            offer = itemsDecoded[offerId].offer;
                            voucherOptionalService = offer.getOptionalServiceByID(optionId);
                            if (voucherOptionalService &&
                                offer.usesOption(voucherOptionalService)) {
                                offer.cancelOption(voucherOptionalService, false);
                                itemsDecoded[offerId].offer = offer;
                                update = true;
                            }
                        }
                        if (!update)
                            return [3 /*break*/, 3];
                        return [4 /*yield*/, BasketAssistant.updateItems(itemsDecoded)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BasketAssistant.usesAnyItemOptionWithCode = function (optionId) {
        return __awaiter(this, void 0, void 0, function () {
            var items, includesVoucher, offerId, offer, optionalService;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BasketAssistant.getItems()];
                    case 1:
                        items = _a.sent();
                        includesVoucher = false;
                        for (offerId in items) {
                            offer = items[offerId].offer;
                            optionalService = offer.getOptionalServiceByID(optionId);
                            if (optionalService) {
                                includesVoucher =
                                    includesVoucher || offer.usesOption(optionalService);
                            }
                        }
                        return [2 /*return*/, includesVoucher];
                }
            });
        });
    };
    BasketAssistant.addOffer = function (item, amount, track) {
        if (track === void 0) {
            track = true;
        }
        return __awaiter(this, void 0, void 0, function () {
            var storage, totalAmount, itemsDecoded, equalOffer, basketItem, uniqueStr, updatedBasket, result, addToCartTracking, callbacks, _i, callbacks_4, callback;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // workaround fix hey lets add simply the options id
                        item.id = item.id.split("+")[0];
                        storage = BasketAssistant.storage;
                        return [4 /*yield*/, BasketAssistant.getTotalAmount()];
                    case 1:
                        totalAmount = _a.sent();
                        if (totalAmount >= BasketAssistant.MAX_ITEMS_ALLOWED) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, BasketAssistant.getItems()];
                    case 2:
                        itemsDecoded = _a.sent();
                        return [4 /*yield*/, BasketAssistant.getEqualBasketItem(item, itemsDecoded)];
                    case 3:
                        equalOffer = _a.sent();
                        if (equalOffer) {
                            itemsDecoded[equalOffer].amount += amount ? amount : 1;
                        }
                        else {
                            basketItem = new BasketItem();
                            basketItem.offer = item;
                            if (amount) {
                                basketItem.amount = amount;
                            }
                            uniqueStr = item.usedOptions.reduce(function (acc, curr) { return acc + "+" + curr.id; }, "");
                            itemsDecoded[item.id + uniqueStr] = basketItem;
                        }
                        this.items = itemsDecoded;
                        updatedBasket = BasketAssistant.updateLastModifiedDate();
                        return [4 /*yield*/, storage.setItem("basket", JSON.stringify(itemsDecoded))];
                    case 4:
                        result = _a.sent();
                        if (track) {
                            addToCartTracking = new TrackingAddToCart();
                            addToCartTracking.track();
                        }
                        return [4 /*yield*/, updatedBasket];
                    case 5:
                        _a.sent();
                        callbacks = BasketAssistant.eventListeners.itemsAdded;
                        for (_i = 0, callbacks_4 = callbacks; _i < callbacks_4.length; _i++) {
                            callback = callbacks_4[_i];
                            callback(itemsDecoded);
                        }
                        BasketAssistant.setThunderBasket();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketAssistant.getEqualBasketItem = function (item, itemsDecoded) {
        var equalOffer;
        for (var offerId in itemsDecoded) {
            if (itemsDecoded[offerId].offer.isEqualOffer(item)) {
                equalOffer = offerId;
            }
        }
        return equalOffer;
    };
    BasketAssistant.getTotalAmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var items, totalAmount, key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BasketAssistant.getItems()];
                    case 1:
                        items = _a.sent();
                        totalAmount = 0;
                        for (key in items) {
                            totalAmount += items[key].amount;
                        }
                        return [2 /*return*/, totalAmount];
                }
            });
        });
    };
    BasketAssistant.getIncludesDeviceInsurance = function () {
        return __awaiter(this, void 0, void 0, function () {
            var items, includesDeviceInsurance, key, itemHasDeviceInsurance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BasketAssistant.getItems()];
                    case 1:
                        items = _a.sent();
                        includesDeviceInsurance = false;
                        for (key in items) {
                            itemHasDeviceInsurance = this.checkItemDeviceInsurance(items[key]);
                            includesDeviceInsurance =
                                includesDeviceInsurance || itemHasDeviceInsurance;
                        }
                        return [2 /*return*/, includesDeviceInsurance];
                }
            });
        });
    };
    BasketAssistant.checkItemDeviceInsurance = function (item) {
        var itemHasDeviceInsurance = item.offer.insuranceOption.findIndex(function (opt) {
            return opt.description.additional.type ===
                SERVICE_TYPE_DEVICE_INSURANCE;
        }) > -1;
        return itemHasDeviceInsurance;
    };
    BasketAssistant.increment = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var storage, totalAmount;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storage = BasketAssistant.storage;
                        return [4 /*yield*/, BasketAssistant.getTotalAmount()];
                    case 1:
                        totalAmount = _a.sent();
                        if (totalAmount + 1 > BasketAssistant.MAX_ITEMS_ALLOWED) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, BasketAssistant.addOffer(item.offer, 1)];
                    case 2:
                        _a.sent();
                        clearTimeout(BasketAssistant.amountChangeTrackingTimeout);
                        BasketAssistant.amountChangeTrackingTimeout = setTimeout(function () {
                            return __awaiter(_this, void 0, void 0, function () {
                                var cartAddTracking, tariff, product, offer, kiasCode, amount, _i, _a, component;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            cartAddTracking = new TrackingCartAddUpdate();
                                            _i = 0, _a = item.offer.components;
                                            _b.label = 1;
                                        case 1:
                                            if (!(_i < _a.length))
                                                return [3 /*break*/, 6];
                                            component = _a[_i];
                                            if (!(component.type === "hardwareMobile"))
                                                return [3 /*break*/, 3];
                                            return [4 /*yield*/, ProductsService.findOneById(component.refId)];
                                        case 2:
                                            product = _b.sent();
                                            _b.label = 3;
                                        case 3:
                                            if (!(component.type === "tariffMobile"))
                                                return [3 /*break*/, 5];
                                            return [4 /*yield*/, findOneById(component.refId)];
                                        case 4:
                                            tariff = _b.sent();
                                            _b.label = 5;
                                        case 5:
                                            _i++;
                                            return [3 /*break*/, 1];
                                        case 6:
                                            offer = item.offer;
                                            kiasCode = tariff.getKIASCode();
                                            amount = item.amount + 1;
                                            cartAddTracking.addOOrder(tariff, product, offer, kiasCode, amount);
                                            cartAddTracking.track();
                                            return [2 /*return*/];
                                    }
                                });
                            });
                        }, BasketAssistant.TRACKING_AMOUNT_CHANGE_DELAY);
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketAssistant.decrement = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var storage, itemsDecoded, equalOffer, result, callbacks, _i, callbacks_5, callback;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storage = BasketAssistant.storage;
                        return [4 /*yield*/, BasketAssistant.getItems()];
                    case 1:
                        itemsDecoded = _a.sent();
                        return [4 /*yield*/, BasketAssistant.getEqualBasketItem(item.offer, itemsDecoded)];
                    case 2:
                        equalOffer = _a.sent();
                        if (itemsDecoded[equalOffer]) {
                            itemsDecoded[equalOffer].amount -= 1;
                            if (itemsDecoded[equalOffer].amount <= 0) {
                                delete itemsDecoded[equalOffer];
                            }
                        }
                        else {
                            throw new Error("Cannot decrease amount of basketItem because it does not exist.");
                        }
                        this.items = itemsDecoded;
                        BasketAssistant.updateLastModifiedDate();
                        return [4 /*yield*/, storage.setItem("basket", JSON.stringify(itemsDecoded))];
                    case 3:
                        result = _a.sent();
                        callbacks = BasketAssistant.eventListeners.itemsDeleted;
                        for (_i = 0, callbacks_5 = callbacks; _i < callbacks_5.length; _i++) {
                            callback = callbacks_5[_i];
                            callback(itemsDecoded);
                        }
                        clearTimeout(BasketAssistant.amountChangeTrackingTimeout);
                        BasketAssistant.amountChangeTrackingTimeout = setTimeout(function () {
                            return __awaiter(_this, void 0, void 0, function () {
                                var cartRemoveTracking, tariff, product, offer, kiasCode, amount, _i, _a, component;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            cartRemoveTracking = new TrackingCartRemoveUpdate();
                                            _i = 0, _a = item.offer.components;
                                            _b.label = 1;
                                        case 1:
                                            if (!(_i < _a.length))
                                                return [3 /*break*/, 6];
                                            component = _a[_i];
                                            if (!(component.type === "hardwareMobile"))
                                                return [3 /*break*/, 3];
                                            return [4 /*yield*/, ProductsService.findOneById(component.refId)];
                                        case 2:
                                            product = _b.sent();
                                            _b.label = 3;
                                        case 3:
                                            if (!(component.type === "tariffMobile"))
                                                return [3 /*break*/, 5];
                                            return [4 /*yield*/, findOneById(component.refId)];
                                        case 4:
                                            tariff = _b.sent();
                                            _b.label = 5;
                                        case 5:
                                            _i++;
                                            return [3 /*break*/, 1];
                                        case 6:
                                            offer = item.offer;
                                            kiasCode = tariff.getKIASCode();
                                            amount = item.amount - 1;
                                            cartRemoveTracking.addOOrder(tariff, product, offer, kiasCode, amount);
                                            cartRemoveTracking.track();
                                            return [2 /*return*/];
                                    }
                                });
                            });
                        }, BasketAssistant.TRACKING_AMOUNT_CHANGE_DELAY);
                        BasketAssistant.setThunderBasket();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketAssistant.updateLastModifiedDate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storage, date, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storage = BasketAssistant.storage;
                        date = new Date();
                        return [4 /*yield*/, storage.setItem("basketLastModified", date.toString())];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketAssistant.getLastModifiedDate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storage, result, time, date;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storage = BasketAssistant.storage;
                        return [4 /*yield*/, storage.getItem("basketLastModified")];
                    case 1:
                        result = _a.sent();
                        if (!result || result === null) {
                            return [2 /*return*/, new Date()];
                        }
                        time = Date.parse(result);
                        date = new Date();
                        date.setTime(time);
                        return [2 /*return*/, date];
                }
            });
        });
    };
    BasketAssistant.subscribe = function (event, callback) {
        if (!BasketAssistant.eventListeners[event]) {
            BasketAssistant.eventListeners[event] = [];
        }
        BasketAssistant.eventListeners[event].push(callback);
    };
    BasketAssistant.getItems = function () {
        var _this = this;
        return new Promise(function (resolve) {
            return __awaiter(_this, void 0, void 0, function () {
                var items, item;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, BasketAssistant.storage.getItem("basket")];
                        case 1:
                            items = _a.sent();
                            if (items === null) {
                                items = "{}";
                            }
                            items = JSON.parse(items);
                            for (item in items) {
                                items[item] = new BasketItem(items[item]);
                            }
                            resolve(items);
                            return [2 /*return*/];
                    }
                });
            });
        });
    };
    BasketAssistant.trigger = function (event) {
        var callbacks = BasketAssistant.eventListeners[event];
        for (var _i = 0, callbacks_6 = callbacks; _i < callbacks_6.length; _i++) {
            var callback = callbacks_6[_i];
            callback();
        }
    };
    BasketAssistant.generateCbuOfferObject = function (offer) {
        return __awaiter(this, void 0, void 0, function () {
            var mandatoryServices, usedOptions, discounts, cbuTariff, cbuServices, cbuDiscounts, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mandatoryServices = [];
                        usedOptions = [];
                        discounts = [];
                        cbuServices = [];
                        cbuDiscounts = [];
                        return [4 /*yield*/, offer.mandatoryServices[0].items];
                    case 1:
                        if (!_a.sent())
                            return [3 /*break*/, 3];
                        mandatoryServices = offer.mandatoryServices[0].items;
                        return [4 /*yield*/, this.getCbuTariffId(mandatoryServices)];
                    case 2:
                        cbuTariff = _a.sent();
                        cbuServices = cbuServices.concat(this.getCbuServices(mandatoryServices));
                        _a.label = 3;
                    case 3: return [4 /*yield*/, offer.getUsedOptions()];
                    case 4:
                        if (!_a.sent())
                            return [3 /*break*/, 6];
                        return [4 /*yield*/, offer.getUsedOptions()];
                    case 5:
                        usedOptions = _a.sent();
                        cbuServices = cbuServices.concat(this.getCbuServices(usedOptions));
                        _a.label = 6;
                    case 6: return [4 /*yield*/, offer.getDiscounts()];
                    case 7:
                        if (!_a.sent())
                            return [3 /*break*/, 9];
                        return [4 /*yield*/, offer.getDiscounts()];
                    case 8:
                        discounts = _a.sent();
                        cbuDiscounts = cbuDiscounts.concat(this.getCbuDiscounts(discounts));
                        _a.label = 9;
                    case 9:
                        response = {
                            sChan: "Online.Enterprise",
                            NEW: [
                                {
                                    TARIFFID: cbuTariff,
                                    SERVICES: cbuServices,
                                    DISCOUNTS: cbuDiscounts,
                                },
                            ],
                        };
                        return [2 /*return*/, btoa(JSON.stringify(response))];
                }
            });
        });
    };
    BasketAssistant.getCbuTariffId = function (services) {
        var selector = "vluxTariffId";
        for (var _i = 0, services_1 = services; _i < services_1.length; _i++) {
            var service = services_1[_i];
            if (service.description.additional.type === selector) {
                if (service.description.additional.url) {
                    return service.description.additional.url;
                }
            }
        }
        return;
    };
    BasketAssistant.getCbuServices = function (services) {
        var cbuServices = [];
        var serviceTypes = ["vluxServiceId", "bundleOption", "gigaPass"];
        for (var _i = 0, services_2 = services; _i < services_2.length; _i++) {
            var service = services_2[_i];
            if (serviceTypes.includes(service.description.additional.type)) {
                if (service.description.additional.url) {
                    cbuServices.push({
                        SERVICEID: service.description.additional.url,
                    });
                }
            }
        }
        return cbuServices;
    };
    BasketAssistant.getCbuDiscounts = function (discounts) {
        var cbuDiscounts = [];
        var discountTypes = [];
        for (var _i = 0, discounts_1 = discounts; _i < discounts_1.length; _i++) {
            var discount = discounts_1[_i];
            if (discountTypes.includes(discount.description.additional.type)) {
                if (discount.description.additional.url) {
                    cbuDiscounts.push({
                        DISCOUNTID: discount.description.additional.url,
                    });
                }
            }
        }
        return cbuDiscounts;
    };
    BasketAssistant.setThunderBasket = function () {
        return __awaiter(this, void 0, void 0, function () {
            var basketData, basketItems, _a, _b, _i, itemKey, item, tariff, product, offer, amount, insurance, _c, _d, component, tariffId, hardwareId, usedOptions, insuranceKey, usedOptionsStr, basketItemKey, basketItem, e_3;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        basketData = JSON.parse("{}");
                        return [4 /*yield*/, BasketAssistant.getItems()];
                    case 1:
                        basketItems = _e.sent();
                        _a = [];
                        for (_b in basketItems)
                            _a.push(_b);
                        _i = 0;
                        _e.label = 2;
                    case 2:
                        if (!(_i < _a.length))
                            return [3 /*break*/, 12];
                        itemKey = _a[_i];
                        _e.label = 3;
                    case 3:
                        _e.trys.push([3, 10, , 11]);
                        item = basketItems[itemKey];
                        tariff = void 0;
                        product = void 0;
                        offer = void 0;
                        amount = void 0;
                        insurance = this.checkItemDeviceInsurance(item);
                        _c = 0, _d = item.offer.components;
                        _e.label = 4;
                    case 4:
                        if (!(_c < _d.length))
                            return [3 /*break*/, 9];
                        component = _d[_c];
                        if (!(component.type === "hardwareMobile"))
                            return [3 /*break*/, 6];
                        return [4 /*yield*/, ProductsService.findOneById(component.refId)];
                    case 5:
                        product = _e.sent();
                        _e.label = 6;
                    case 6:
                        if (!(component.type === "tariffMobile"))
                            return [3 /*break*/, 8];
                        return [4 /*yield*/, findOneById(component.refId)];
                    case 7:
                        tariff = _e.sent();
                        _e.label = 8;
                    case 8:
                        _c++;
                        return [3 /*break*/, 4];
                    case 9:
                        offer = item.offer;
                        amount = item.amount;
                        tariffId = tariff.id;
                        hardwareId = product
                            ? product.getCurrentVersion().id
                            : undefined;
                        usedOptions = offer
                            .getUsedOptions()
                            .map(function (opt) { return parseInt(opt.id); })
                            .sort(function (a, b) { return a - b; });
                        insuranceKey = product ? (insurance ? 1 : 0) : "-";
                        usedOptionsStr = usedOptions
                            .reduce(function (acc, curr) { return acc + "-" + curr; }, "")
                            .substring(1);
                        if (usedOptions.length == 0) {
                            usedOptionsStr = "-";
                        }
                        basketItemKey = (tariffId + "_" + hardwareId + "_" + usedOptionsStr + "_" + insuranceKey).replace(/undefined/g, "-");
                        basketItem = {
                            tariffId: tariffId,
                            hardwareId: hardwareId,
                            optionIds: usedOptions,
                            insurance: insurance,
                            quantity: amount,
                        };
                        basketData[basketItemKey] = basketItem;
                        return [3 /*break*/, 11];
                    case 10:
                        e_3 = _e.sent();
                        console.log("Error setting thunder basket item");
                        return [3 /*break*/, 11];
                    case 11:
                        _i++;
                        return [3 /*break*/, 2];
                    case 12:
                        window.localStorage.setItem("basket", JSON.stringify(basketData));
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketAssistant.MAX_ITEMS_ALLOWED = 49;
    BasketAssistant.TRACKING_AMOUNT_CHANGE_DELAY = 2501;
    BasketAssistant.eventListeners = {
        itemsAdded: [],
        itemsDeleted: [],
        continueShopping: [],
        itemsRefreshed: [],
    };
    BasketAssistant.items = {};
    return BasketAssistant;
}());
export { BasketAssistant };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/services/basket/basket-assistant.ts
// module id = null
// module chunks = 